module.exports = __webpack_public_path__ + "media/images/groupphasebet__sample@2x-334143034064f9d2e42f82b67e436ecb.png";